import React, { ReactElement } from 'react';
import { Row, Col } from 'antd';
import image from '../../images/empty_result.png';
import './EmptyResultPage.less';

export type EmptyResultPageProps = {
  title?: string | ReactElement;
  second_title?: string;
  path_to_img?: string;
  imgWidth?: string;
};

const TEmptyResultPage: React.FC<EmptyResultPageProps> = ({
  title = '',
  second_title = '',
  path_to_img = image,
  imgWidth = '',
}) => {
  return (
    <Row gutter={24} className="t_empty_result_container">
      {path_to_img && (
        <Col className="t_img_container">
          <img
            src={path_to_img}
            alt="Empty Result Page"
            style={{ width: imgWidth }}
          />
        </Col>
      )}
      {title ||
        (second_title && (
          <Col className="t_title">
            {title && <p>{title}</p>}
            {second_title && <p>{second_title}</p>}
          </Col>
        ))}
    </Row>
  );
};

export default TEmptyResultPage;
